




























































import masterdata, {
    MDServerResponse,
    NewCustomerListContent,
    UpdateCCRequest,
} from '@/services/masterdata';
import ShowMDResponse from '@/components/masterData/components/ShowMDResponse.vue';
import CCSelect from '@/components/masterData/components/CCSelect.vue';

export default {
    components: {
        'md-response': ShowMDResponse,
        'md-selectCC': CCSelect,
    },
    data(this: any): any {
        return {
            form: {} as UpdateCCRequest,
            resivedData: false,
            companycode: 0,
            societa: 0,
            societaUser: 0,
            moreAgent: false,
            customercare: '',
            lists: {} as NewCustomerListContent,
            step: 0,
            filiale: '',
            filialiPAO: '',
            filialiFTL: '',
            filialiXTL: '',
            filialiLTL: '',
            errors: [],
            response: null,
            formstyle: {
                labelwidth: '150px',
                labelposition: 'right',
            },
        };
    },
    methods: {
        async getData(this: any) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            let lists: NewCustomerListContent | undefined;
            try {
                lists = await masterdata.getCustomerListContent(this.companycode, this.societa, this.societaUser);
            } catch (error) {
                masterdata.errorMessageAlert(this, error, loading, 'masterData.GetFailed', 'masterData.ListGetFailed');
                return;
            }
            loading.close();
            if (lists !== null) {
                this.lists = lists;
                this.resivedData = true;
            } else {
                this.$alert(this.$t('masterData.NewCustomerFailedMessage'), this.$t('masterData.NewCustomerFailedTitel'), { type: 'error', confirmButtonText: 'OK', center: true });
            }
        },
        async nextStep(this: any, formName: string) {
            this.step += 1;
            this.onSubmit();
        },
        backStep(this: any, formName: string) {
            this.$router.push({ path: '/masterdata', query: { companycode: this.companycode, societa: this.societa, societaUser: this.societaUser } });
        },
        async onSubmit(this: any) {
            const loading = this.$loading({ lock: true, text: 'Loading', background: 'rgba(0, 0, 0, 0.7)' });
            this.error = [];
            this.prepareFormForSubmit();
            let response: MDServerResponse | undefined;
            try {
                response = await masterdata.sendUpdateCC(this.companycode, this.societa, this.societaUser, this.form);
            } catch (error) {
                if (error.response != null && Array.isArray(error.response.data)) {
                    this.errors = error.response.data;
                    loading.close();
                } else {
                    masterdata.errorMessageAlert(this, error, loading, 'masterData.NewCustomerFailedTitel', 'masterData.NewCustomerFailedMessage', false);
                    this.step -= 1;
                }
                this.form.customercare_FTL = '';
                this.form.customercare_LTL = '';
                this.form.customercare_XTL = '';
                this.form.customercare_PAO = '';
                this.customercare = '';
                return;
            }
            loading.close();
            this.response = response;
        },
        prepareFormForSubmit(this: any) {
            if (!this.moreAgent) {
                this.form.customercare_FTL = this.customercare;
                this.form.customercare_LTL = this.customercare;
                this.form.customercare_XTL = this.customercare;
                this.form.customercare_PAO = this.customercare;
            }
        },
    },
    mounted(this: any) {
        this.companycode = this.$route.query.companycode;
        this.societa = this.$route.query.societa;
        this.societaUser = this.$route.query.societaUser;
        this.form.date = new Date();
        this.getData();
    },
};
